import { Brand } from '@elio/emanager-front/shared/app-config';

export const brand: Brand = {
  appName: 'e-lioManager',
  tel: '04 76 230 240',
  address: '55 route de Lyon 38000 Grenoble',
  email: 'serviceclient@technosens.fr',
  legalNoticesLink: '/eliomanager/eliomanager-legal-notices/eliomanager-legal-notices.html',
  cguLink: '/eliomanager/eliomanager-cgu/eliomanager-terms-conditions.html',
  connectionHelperLink: '/eliomanager/eliomanager-connection/eliomanager-connection.html',
};
